import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileSignature } from "lucide-react";
import { Sign } from "@/lib/api";

const MODES = [["off", "Desligada"], ["warn", "Aviso"], ["block", "Bloqueio"]];

// Admin: modo de cada regra por consentimento (só atua com o MIO Sign ativo).
export default function SignRulesPanel() {
  const [d, setD] = useState(null);
  useEffect(() => { Sign.rules().then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const set = async (op, mode) => {
    try { setD(await Sign.setRules({ [op]: mode })); toast.success("Regra atualizada"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Não foi possível guardar"); }
  };
  return (
    <div className="rounded-2xl border border-sky-500/20 bg-slate-900/50 p-6 space-y-3" data-testid="sign-rules-panel">
      <div className="text-xs uppercase tracking-[0.2em] text-sky-400 font-semibold flex items-center gap-2">
        <FileSignature className="w-3.5 h-3.5" /> MIO Sign · Regras por consentimento
      </div>
      <p className="text-[12px] text-slate-400">Aviso informa e deixa continuar; Bloqueio impede até haver o documento. A consulta de dados existentes nunca é bloqueada. Minutas não validadas: usar apenas com dados fictícios.</p>
      {Object.entries(d.labels).map(([op, label]) => (
        <div key={op} className="flex flex-wrap items-center justify-between gap-2 text-sm">
          <span className="text-slate-200">{label}</span>
          <select data-testid={`sign-rule-${op}`} value={d.rules[op]} onChange={(e) => set(op, e.target.value)}
            className="rounded-full bg-slate-950 border border-slate-700 text-slate-200 text-xs px-3 py-1.5">
            {MODES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
      ))}
      <div className="text-[11px] text-slate-500">IA externa: mantém-se a regra atual (recusa ou retirada da autorização bloqueia a IA).</div>
    </div>
  );
}
